import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import { useAuthStore, init } from './stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(async () => {
    const authStore = useAuthStore()
    if(authStore.isLoggedIn){
        await init()
    }
})


return (_ctx: any,_cache: any) => {
  const _component_LayoutSystem = _resolveComponent("LayoutSystem")!
  const _component_ImageBox = _resolveComponent("ImageBox")!
  const _component_FileUploadBox = _resolveComponent("FileUploadBox")!
  const _component_AlertBox = _resolveComponent("AlertBox")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LayoutSystem),
    _createVNode(_component_ImageBox),
    _createVNode(_component_FileUploadBox),
    _createVNode(_component_AlertBox),
    _createVNode(_component_notifications, {
      position: "top center",
      classes: "my-notification"
    })
  ], 64))
}
}

})